import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CityState {
  editId: number | null
  isCreateModalOpen: boolean
}

const initialState: CityState = {
  editId: null,
  isCreateModalOpen: false
}

const citySlice = createSlice({
  name: 'city',
  initialState,
  reducers: {
    setEditId: (state, action: PayloadAction<number | null>) => {
      state.editId = action.payload
    },
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    }
  }
})

export const cityActions = citySlice.actions
export const { reducer: cityReducer } = citySlice
